<template>
    <b-input
        v-model="value"
        v-on:keyup.enter="$emit('on-enter', $event)"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)"
        class="border border-dark"
    ></b-input>
</template>

<script>
export default {
    // props: ['modelValue'],
    props: {
        modelValue: {

        }
    },
    emits: ['update:modelValue'],
    computed: {
        value: {
            get() {
                // alert(this.modelValue)
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    } 
}
</script>

<style>

</style>